
import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import { BrowserRouter } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "./components/ui/toaster.tsx";
import { Toaster as SonnerToaster } from "sonner";
import { 
  trackPageView, 
  initializeGoogleAnalytics 
} from "./utils/tagManagerUtils.ts";
import { GDPRProvider } from "./components/gdpr/GDPRProvider.tsx";

// Paddle initialization removed - not needed for marketing site

void initializeGoogleAnalytics().then(() => {
  trackPageView();
});

// Ensure document body has the background color applied
document.body.classList.add('bg-background');

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <HelmetProvider>
      <BrowserRouter>
        <GDPRProvider>
          <App />
          <Toaster />
          <SonnerToaster position="top-right" closeButton />
        </GDPRProvider>
      </BrowserRouter>
    </HelmetProvider>
  </React.StrictMode>
);
